import { ArrowLeftIcon, ArrowRightIcon } from "@/components/icons";
import { getArrowIconButtonStyle } from "@/utils/helpers";
import clsx from "clsx";
import SubtileShine from "../SubtileShine";

interface CarouselControlsProps {
  progress: number;
  canScrollPrev: boolean;
  canScrollNext: boolean;
  scrollPrev: () => void;
  scrollNext: () => void;
}

export default function CarouselControls({ progress, canScrollPrev, canScrollNext, scrollPrev, scrollNext }: CarouselControlsProps) {
  return (
    <div className="flex items-center gap-[20px] xl:gap-[60px]">
      {/* Progress bar */}
      <div className="flex-1 h-[2px] bg-gray-200 relative">
        <div
          className="absolute left-0 top-0 h-full bg-[#d3b895] transition-all duration-200"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Arrows */}
      <div className="flex gap-[8px]">
        <button aria-label="arrow-left" onClick={scrollPrev}>
          <div className="relative inline-block">
            <ArrowLeftIcon
              width={20} height={20}
              color={clsx(canScrollPrev ? "white" : "#A58760")}
              className={getArrowIconButtonStyle(canScrollPrev)}
            />
            <SubtileShine />
          </div>
        </button>
        <button aria-label="arrow-right" onClick={scrollNext}>
          <div className="relative inline-block">
            <ArrowRightIcon
              width={20} height={20}
              color={clsx(canScrollNext ? "white" : "#A58760")}
              className={getArrowIconButtonStyle(canScrollNext)}
            />
            <SubtileShine />
          </div>
        </button>
      </div>
    </div>
  )
}